<template>
  <div>
    <div class="share-head" v-if="shareModal">
      <van-image width="38" height="38" :src="require('../../assests/imgs/logo.png')" />
      <div class="share-text">
        <span>小豆苗</span>
        <span>管理宝宝打疫苗的APP</span>
      </div>
      <span id="more" :class="{'more-btn': !isWx}" class="more-wrapper"><span class="more">查看更多</span></span>
      <span class="share-close" @click="downLoadClose"></span>
    </div>
    <span class="share-btn" id="share-btn">我也要测评</span>
  </div>
</template>

<script>
import {Image as VanImage} from 'vant';
import {OpenApp} from '@threegene/common-js/xdm/share/index';
import wx from 'weixin-js-sdk';
export default {
  name: 'Share',
  components: {
    VanImage
  },
  props: {
    path: String
  },
  data() {
    return {
      shareModal: true,
      isWx: /micromessenger/.test(navigator.userAgent.toLowerCase())
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.isWx) {
        this.init();
      } else {
        this.initOpenApp();
      }
    });
  },
  methods: {
    initOpenApp() {
      OpenApp.init({
        isOnline: window.location.host === 'dm.yeemiao.com',
        extro: [
          {
            path: this.path,
            containerId: 'more',
            html: '  <span style="display:inline-block;width: 80px;height: 33px;line-height: 33px;  border-radius: 50px; text-align: center; background-color: #7bd557;color: #fff;  font-size: 14px;" >查看更多</span>'
          },
          {
            path: this.path,
            containerId: 'share-btn',
            html: '<span style="display:inline-block;width: 122px;font-size: 16px;color: #fff; border-radius: 100px; box-sizing: border-box; background-image: linear-gradient(132deg, #a0da3a 0%, #afe823 100%);text-align: center;line-height: 35px;" >我也要测评</span>'
          }
        ]
      });
    },
    downLoadClose() {
      this.shareModal = false;
    },
    async init() {
      const data = await this.handleAPI('config', {url: window.cacheUrl});
      wx.config({
        debug: false,
        appId: data.appid, // 公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'],
        openTagList: ['wx-open-launch-app'] // 微信开放标签 小程序跳转按钮：<wx-open-launch-weapp>
      });

      wx.ready(() => {
        console.log('ready');
        this.initOpenApp();
      });
    }
  },

  toTest() {
    location.href = 'https://dm.yeemiao.com/share/openBrowser.html';
  }
};
</script>

<style lang="less" scoped>
.share-head {
  display: flex;
  padding: 0 30px;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  height: 120px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  box-sizing: border-box;
  z-index: 999;

  .share-text {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-left: 20px;
    color: #fff;
    font-size: 28px;
    line-height: 1;

    span:first-child {
      font-size: 32px;
      font-weight: bold;
    }

    span + span {
      padding-top: 8px;
    }
  }
  .more-wrapper {
    display: flex;
    align-items: center;
  }
  .more {
    display: inline-block;
    width: 160px;
    height: 66px;
    line-height: 66px;
    border-radius: 100px;
    text-align: center;
    background-color: #7bd557;
    color: #fff;
    font-size: 28px;
  }

  .more-btn {
    width: 158px;
    height: 52px;
    line-height: 52px;
    font-size: 28px;
    color: #fff;
    text-align: center;
    background-color: #7bd557;
    border-radius: 26px;
  }
}

.share-close {
  width: 60px;
  height: 60px;
  background: url('./imgs/icon_quxiao@3x.png') no-repeat center;
  background-size: 34px 34px;
}

.share-btn {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 80px;
  z-index: 999;
  box-sizing: border-box;
  width: 244px;
  height: 70px;
  line-height: 70px;
  font-size: 32px;
  color: #fff;
  text-align: center;
  background-image: linear-gradient(132deg, #a0da3a 0%, #afe823 100%);
  border-radius: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Share/index.vue